import { createSlice } from "@reduxjs/toolkit";
import { uploadFileApi } from "./uploadFileApi";
import { store } from "../store";
const initialState = {
  uuid: sessionStorage.getItem("uuid"),
  statistics: null,
  errors: null,
};
const uploadFileSlice = createSlice({
  name: "uploadFileSlice",
  initialState,
  reducers: {
    setUuid(state, action) {
      state.uuid = action.payload;
      sessionStorage.setItem("uuid", action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      store.uploadFileEndpoints.getFileStatistic.matchFulfilled,
      (state, action) => {
        state.statistics = action.payload.data.attributes;
      }
    );
    builder.addMatcher(
      store.uploadFileEndpoints.getFileErrors.matchFulfilled,
      (state, action) => {
        state.errors = action.payload.data[0].attributes;
      }
    );
  },
});
export const { setUuid } = uploadFileSlice.actions;
export default uploadFileSlice.reducer;
